import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: 'Home'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: 'Products'
          },
          children: [
            {
              path: '/software/medicine',
              name: 'softwareMedicine',
              component: resolve => require(['@/view/SoftwareMedicine'], resolve),
              meta: {
                title: 'Products丨Smart Medicine Purchase Order Matching System'
              }
            },
            {
              path: '/software/eventTracking',
              name: 'softwareEventTracking',
              component: resolve => require(['@/view/SoftwareEventTracking'], resolve),
              meta: {
                title: 'Products丨App Event Tracking And Analysis System'
              }
            },
            {
              path: '/software/userBehavior',
              name: 'softwareUserBehavior',
              component: resolve => require(['@/view/SoftwareUserBehavior'], resolve),
              meta: {
                title: 'Products丨App User Behavior Analysis System'
              }
            },
            {
              path: '/software/contract',
              name: 'softwareContract',
              component: resolve => require(['@/view/SoftwareContract'], resolve),
              meta: {
                title: 'Products丨Contract Management System'
              }
            },
            {
              path: '/software/crm',
              name: 'softwareCRM',
              component: resolve => require(['@/view/SoftwareCRM'], resolve),
              meta: {
                title: 'Products丨CRM System'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: 'Services'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: 'News'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: 'About Us'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: 'Job Opportunities'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: 'Contact Us'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: 'Services'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js